import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseService } from '../../base.service';
import { BankService } from '../../services/bank.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BankListItem } from '../../models/bankListItem';
import { FormBuilder } from '@angular/forms';
import {Location} from '@angular/common';
import { environment } from '../../../environments/environment';
import { AngularFireStorage } from 'angularfire2/storage';
import { finalize } from 'rxjs/operators';
import { Env } from '../../env';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-bank',
  templateUrl: './create-bank.component.html',
  styleUrls: [ ]
})
export class CreateBankComponent implements OnInit {
  @ViewChild('fileinput') fileinput: ElementRef;

  constructor(
    private baseService : BaseService ,
    private bankService : BankService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private storage: AngularFireStorage, 
    private global: Env,
    private toastr: ToastrService,
  ) { }
  private bankForm = this.fb.group({
    name: [''],
    //status: ['']
  });
  

  loadingMensaje:string = "";
  loadingRequest:boolean =  false;
  loading( status:boolean , men:string = "" ){
    this.loadingMensaje = men;
    this.loadingRequest = status;
  }
  titleComponent:string;
  titlePanel:string;
  bank:BankListItem;
  bankId:number = 0;


  ngOnInit() {
    this.titleComponent = 'Nuevo Banco';
    this.titlePanel = '';
    this.baseService.changedComponentName(this.titleComponent);
  }

  albumThumbURLs:String = "";
  albumThumbFile: File = null;
  updateSinglePic($event){
    let files:FileList = $event.target  .files;
    let r = files[0];
    this.albumThumbFile = r;
    let reader = new FileReader(); 
    reader.readAsDataURL(r);
    reader.onload = (_event) => {
      let co = reader.result;
      //console.log(co);
      this.albumThumbURLs = <String>co; 
    }
    this.fileinput.nativeElement.value = "";
  }

  onSubmit(){
    //console.log(this.bankForm.value.name);
    // si albumThumbFile es null solo sube la data
    console.log(this.bankForm.value.title,this.bankForm.value.message);
    if ( !(this.bankForm.value.name > '' )) {
      this.showError('El slide debe tener un nombre.');
    } else {
      console.log('creando');
      this.loading(true,"Creando Slide...");
        
        this.bankService.createBank( environment.bankDefaultImage , this.bankForm.value.name  ).subscribe( r => {
          //this.router.navigate(['/dashboard/banks']);
          if  ( this.albumThumbFile ) {
            console.log(r);
            if(r){
              
              this.loading(true, "Subiendo imagen...");
              let re:any = r;
              //this.showSuccess("Banco Registrado");
              let blobName = "slide-"+re.id;
              let extensionName = this.albumThumbFile.name.split('.').pop();
              let filePath = `${environment.env}/${this.global.FOLDER_IMAGES['Bank']}/${blobName}.${extensionName}`;
              let ref = this.storage.ref(filePath);
              
              let task = this.storage.upload(filePath, this.albumThumbFile );
              //ref.getDownloadURL( r => {console.log(r);} );
              task.snapshotChanges().pipe(
                finalize(() => {
                  this.loading(true, "Redireccionando...");
                  let downloadURL = ref.getDownloadURL()
                  downloadURL.subscribe( url => { 
                    console.log( url );
                    this.albumThumbFile = null;
                      this.bankService.updateBank(  url , this.bankForm.value.name , re.id ).subscribe( r => {
                        //poner mensaje de exito
                        //console.log('r',r);
                        this.loading(false);
                        this.showSuccess("Información actualizada con éxito.");
                        this.router.navigate(['/dashboard/banks']);
                        //this.get(this.bank.id);
                      }, err => {
                        this.loading(false);
                        this.showError("Hubo un error en el servidor");
                      });
                    });
                })
              ).subscribe();
            }
          } else {
            this.loading(true, "Redireccionando...");
            this.router.navigate(['/dashboard/banks']);
          }
          
          
        } , err => {
          this.loading(false);
          this.showError("Hubo un error en el servidor (1)");
        })
      
    } 
  }

  showSuccess(message: string): any {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message: string): any {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/bank/create-bank.component.ts